import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MembersListComponent } from './modules/members/members-list/members-list.component';
import { PlotsListComponent } from './modules/plots/plots-list/plots-list.component';
import { ItemsListComponent } from './modules/items/items-list/items-list.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { LoginComponent } from './layout/components/login/login.component';
import { MemberPlotsListComponent } from './modules/member-plots/member-plots-list/member-plots-list.component';
import { LayoutComponent } from './layout/components/layout/layout.component';
import { PlotItemsListComponent } from './modules/plot-items/plot-items-list/plot-items-list.component';
import { authGuard } from './shared/guards/auth.guard';
import { LogoutComponent } from './shared/components/logout.component';
import { WaitingListApplicantsListComponent } from './modules/waiting-list-applicants/waiting-list-applicants-list/waiting-list-applicants-list.component';


const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: "members", pathMatch: 'full' },
      { path: 'members', component: MembersListComponent, canActivate: [authGuard] },
      { path: 'waiting-list-applicants', component: WaitingListApplicantsListComponent, canActivate: [authGuard] },
      { path: 'plots', component: PlotsListComponent, canActivate: [authGuard] },
      { path: 'items', component: ItemsListComponent, canActivate: [authGuard] },
      {
        path: 'invoices',
        canActivate: [authGuard],
        loadChildren: () => import('./modules/invoices/invoices.module').then(m => m.InvoicesModule)
      },
      { path: 'members/:memberId/plots', component: MemberPlotsListComponent,  canActivate: [authGuard] },
      { path: 'plots/:plotId/items', component: PlotItemsListComponent, canActivate: [authGuard] },
      { path: 'login', component: LoginComponent, },
      { path: 'logout', component: LogoutComponent, },
      {
        path: 'admin',
        data: { roles: ['Admin'] },
        canActivate: [authGuard],
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
      },
      { path: '**', component: NotFoundComponent, data: { title: 'Not Found' } }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
